export default function MetricsHeader({ title }: { title: string }) {
  return (
    <div className="text-center border-b-2 py-3 bg-gray-100 w-full">
      <h2 className="font-semibold text-2xl text-gray-500">{title}</h2>
    </div>
  );
}
